import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { Locale, getLocale, setSiteLocale } from '../../../common/i18n/index.js';
import { useAuth } from '../../../public/site/AuthProvider.js';
import { setFooterVisibility } from '../../../selfservice/actions/index.js';
import { OpenFormProvider } from '../OpenFormProvider.js';
import { isIframe } from '../OpenFormUtils.js';
import { OpenFormLayoutCanvas } from './OpenFormLayoutCanvas.js';
import { OpenFormLayoutOnline } from './OpenFormLayoutOnline.js';

export const OpenFormLayout = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const [search] = useSearchParams();

  useEffect(() => {
    document?.documentElement?.style?.setProperty('scrollbar-gutter', 'stable both-edges');
    dispatch(setFooterVisibility(false));

    switch (search.get('locale')) {
      default: // Only Finnish supported in the first version
        getLocale() !== Locale.FI && setSiteLocale(Locale.FI);
    }

    return () => {
      document?.documentElement?.style?.removeProperty('scrollbar-gutter');
      dispatch(setFooterVisibility(true));
    };
  }, [dispatch, search]);

  return (
    <OpenFormProvider accountMasterId={auth?.authenticatedUser?.activeAccountMasterId}>
      {isIframe() ? <OpenFormLayoutCanvas auth={auth} /> : <OpenFormLayoutOnline auth={auth} />}
    </OpenFormProvider>
  );
};
